import { toast } from 'sonner';
import { SERVER_ADDRESS, SERVER_IP } from '../config/links';

/**
 * Copies the server address and reports the outcome. Shared by the header
 * button and the command palette so the two cannot drift apart.
 */
export async function copyServerIp(copy) {
  const ok = await copy(SERVER_ADDRESS);

  if (ok) {
    toast.success('Server IP copied', { description: SERVER_IP });
  } else {
    // Never fail silently: if the clipboard is blocked, the player still needs
    // the address.
    toast.error('Could not copy the IP', { description: `Connect to ${SERVER_IP}` });
  }

  return ok;
}
